module.exports = __webpack_public_path__ + "img/1_016.24cd3aa2.jpg";